(() => {
  const BUNDLE_VARIANT_ID = 50527696191531;
  const GIFT_VARIANT_ID = 50516879081515;

  let syncing = false;

  async function syncFreeGift() {
    if (syncing) return;

    syncing = true;

    try {
      const cartResponse = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json',
        },
      });

      if (!cartResponse.ok) return;

      const cart = await cartResponse.json();

      const hasBundle = cart.items.some(
        (item) => Number(item.variant_id) === BUNDLE_VARIANT_ID
      );

      const hasGift = cart.items.some(
        (item) => Number(item.variant_id) === GIFT_VARIANT_ID
      );

      // If the qualifying bundle is gone, immediately remove the free sticker.
      if (!hasBundle && hasGift) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            updates: {
              [GIFT_VARIANT_ID]: 0,
            },
          }),
        });

        // Refresh Horizon's cart drawer immediately.
        const response = await fetch(
          `${window.location.pathname}?sections=cart-drawer-section`
        );

        if (response.ok) {
          const sections = await response.json();
          const html = sections['cart-drawer-section'];

          if (html) {
            const parser = new DOMParser();
            const documentFragment = parser.parseFromString(html, 'text/html');

            const newSection = documentFragment.querySelector(
              '#shopify-section-cart-drawer-section'
            );

            const currentSection = document.querySelector(
              '#shopify-section-cart-drawer-section'
            );

            if (newSection && currentSection) {
              currentSection.replaceWith(newSection);
            }
          }
        }
      }
    } catch (error) {
      console.error('Free gift sync error:', error);
    } finally {
      syncing = false;
    }
  }

  // Watch clicks on cart remove buttons.
  document.addEventListener(
    'click',
    (event) => {
      const removeButton = event.target.closest('.cart-items__remove');

      if (!removeButton) return;

      // Give Horizon a moment to finish its own cart update first.
      setTimeout(syncFreeGift, 700);
    },
    true
  );

  // Also check whenever the page regains focus.
  window.addEventListener('focus', syncFreeGift);
})();